import { render } from "./ReachOut_1.vue?vue&type=template&id=06a5d1f4"
import script from "./ReachOut_1.vue?vue&type=script&lang=js"
export * from "./ReachOut_1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__